module.exports = __webpack_public_path__ + "static/media/Pink-P.a1a1ade8.png";